import { combineEpics } from "redux-observable";
import { loadExperimentationGroupsEpicReducer, loadAssignmentUnitsEpicReducer, loadRootExperimentationGroupEpicReducer, loadAnalysisRuleEpicReducer, editAnalysisRuleEpicReducer, loadAnalysisTemplatesEpicReducer } from "../components/AnalysisConfigEditContainer/Edit.epics.js";
const rootEpic = combineEpics(
  loadExperimentationGroupsEpicReducer.epic,
  loadAssignmentUnitsEpicReducer.epic,
  loadRootExperimentationGroupEpicReducer.epic,
  loadAnalysisRuleEpicReducer.epic,
  editAnalysisRuleEpicReducer.epic,
  loadAnalysisTemplatesEpicReducer.epic
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=AnalysisConfigEdit.epics.js.map
